<template>
  <v-stepper v-model="e1" elevation="0">
    <v-stepper-header
        :style="[this.e1 === 3 ? { 'width': '100%'} : {'width': '75%'}]"
    >
      <v-stepper-step
          :complete="e1 > 1"
          step="01"
          :class="{'initial_color_step' : this.e1 === 1}"
      >
        Affiliates
<!--            <p>-->
<!--              {{ JSON.stringify(this.getMultiplySelectAffiliates) }}-->
<!--            </p>-->


      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
          :complete="e1 > 2"
          step="02"
          :class="{'initial_color_step' : this.e1 === 2}"
      >
        Offers
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
          step="03"
          :class="{'initial_color_step' : this.e1 === 3}"
      >
        Confirm Data
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="mb-12" elevation="0" color="white lighten-1">
          <Affiliates
              @activeButton="activeButtonAffiliates = $event"
          ></Affiliates>
        </v-card>

        <div class="flex center" style="margin-right: 15px; margin-top: -42px; margin-bottom: 13px">
          <v-btn
              :disabled="!activeButtonAffiliates"
              color="primary"
              elevation="0"
              @click="continueRoute(`affiliates`)"
          >
            Continue <i class="fas fa-angle-right"></i>
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card class="mb-12" color="white lighten-1">
          <Offers
              :predefined-filters="{
                  status: ['public','private','apply_to_run','pending']
              }"
              @activeButton="activeButtonOffers = $event"
          ></Offers>
        </v-card>
        <div class="flex center" style="margin-right: 15px; margin-top: -42px; margin-bottom: 13px">
          <v-btn
              text
              @click="backRoute(`affiliates`)"
          >
            <i class="fas fa-angle-left"></i> Back
          </v-btn>
          <v-btn
              style="margin-left: 20px;"
              :disabled="!activeButtonOffers"
              color="primary"
              elevation="0"
              @click="continueRoute(`offers`)"
          >
            Continue <i class="fas fa-angle-right"></i>
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
            class="mb-12"
            color="grey lighten-1"
            elevation="0"
        >
          <CreateMassCampaigns></CreateMassCampaigns>
        </v-card>

<!--            <v-btn-->
<!--                color="primary"-->
<!--                @click="continueRoute(`affiliates`)"-->
<!--            >-->
<!--              Create Campaigns-->
<!--            </v-btn>-->

        <div class="flex left" style="margin-top: -10px; margin-bottom: 10px;">
          <v-btn text
                @click="backRoute(`offers`)"
          >
            <i class="fas fa-angle-left"></i> Back
          </v-btn>
        </div>

      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>


<script>
import Affiliates from "./Affiliates"
import Advertisers from "./Advertisers"
import Offers from "./Offers"
import CreateMassCampaigns from "./createMassCampaigns"
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      e1: 1,
      activeButtonAffiliates: false,
      activeButtonOffers: false,
    }
  },
  created() {
    // document.querySelector('.v-stepper__wrapper').style.overflow = 'auto'
  },
  async mounted() {
    // let el = document.querySelectorAll('.v-stepper__wrapper')
    // el.forEach(i => {
    //   i.style.overflow = 'auto'
    // })
  },
  components: {
    Affiliates,
    Advertisers,
    Offers,
    CreateMassCampaigns
  },
  computed: {
    ...mapGetters('advertisers', ['getSflAdvertisers', 'getMultiplySelectAdvertisers']),
    ...mapGetters('affiliates', ['getMultiplySelectAffiliates']),
    ...mapGetters('offers', ['getOffers', 'getMultiplySelectOffers']),
  },
  methods: {
    continueRoute(routeName) {
      switch (routeName) {
        case 'affiliates':
          this.e1 = 2
          // this.$router.push(`/affiliates/multipleCampaignsCreation/${this.e1}`);
          break;
        case 'offers':
          this.e1 = 3
          // this.$router.push(`/affiliates/multipleCampaignsCreation/${this.e1}`);
          break;
        // case 'affiliates':
        //   this.e1 = 1
        //   this.$router.push(`/affiliates/multipleCampaignsCreation/${this.e1}`);
        //   break;
      }
    },
    backRoute(routeName) {
      switch (routeName) {
        case 'affiliates':
          this.e1 = 1
          break;
        case 'offers':
          this.e1 = 2
          break;
        // case 'affiliates':
          // this.e1 = 3
          // this.$router.push(`/affiliates/multipleCampaignsCreation/${this.e1}`);
          // break;
      }
    },
    // getStepper() {
    //   const path = this.$route.path.split('/')
    //   if (path[path.length - 1].toLowerCase() === 'your-router-path') {
    //     this.e1 = 1
    //     // this.e1 = 1 = <v-stepper-step step="1" />
    //     // this.e1 = 2 = <v-stepper-step step="2" />
    //     // and so on.
    //   }
    // }
  }
}
</script>

<style scoped lang="sass">
.v-stepper__header
  position: absolute
  top: 0px
  z-index: 1
  box-shadow: none
  background: #3A3852

.v-stepper__content
  padding: 0
.v-application .mb-12
  margin-bottom: 0!important

svg
  &.svg-inline--fa.fa-angle-left.fa-w-8
    margin-right: 10px
  &.svg-inline--fa.fa-angle-right.fa-w-8
    margin-left: 10px
</style>
